// This enum is used for all the transaction response status we get.
export enum ResultStatus {
  NoProcess = 0,
  Failure = 1,
  Abort = 2,
  Cancel = 3,
  Warning = 4,
  Information = 5,
  NoData = 6,
  Validation = 7,
  Success = 8,
}
export enum responseMessageStatus {
  info = 1,
  warning = 2,
  success = 3,
  error = 4,
}
export enum ResponseStatus {
  success = 1,
  error = 2,
}

// here you need to define the role which you have in project
export enum UserType {
  User = 0,
  Admin = 1,
  SuperAdmin = 2,
  Vendor = 3,
  None = 4,
  SuperTenantAdmin = 5,
}

export enum SupplierType{
  QBO = 0,
  Unlinked = 1
}

export enum BrooklynBillStatus {
  PendingApproval = 1,
  Processing = 2,
  Payment = 3,
  CancellationUnderReview = 4,
  canceled = 5,
  UnderReview = 6,
  Voided = 7,
}

export enum PaybevPaymentStatus {
  Schedule = 1,
  CancellationUnderReview = 2,
  canceled = 3,
  UnderReview = 4,
}

export enum RoleType {
  Internal = 0,
  Operator = 1,
  Supplier = 2,
}
export enum ValidationMessage {
  minlength = 'must contain at least 2 characters',
}

export enum AccountType {
  Operator = 0,
  Supplier = 1,
  SupplierBank = 2,
}

export enum SiteType {
  Operator = 0,
  Supplier = 1,
  SupplierBank = 2,
}

export enum UserTypes {
  Internal = 0,
  Operator = 1,
  Supplier = 2,
}

export enum TypeCategory {
  Account = 0,
  Site = 1,
  Supplier = 2,
}

export enum TransactionsType {
  StartingBalance = 0,
  Investment = 1,
  Payment = 2,
  Transfer = 3,
  Expenses = 4,
  InternalTransfer = 5,
  Refunds = 6,
  Credits = 7,
  Deposits = 8,
}

export enum AssignmentUser {
  ProjectManager = 0,
  Director = 1,
  AccountManager = 2,
  Executive = 3,
  SeniorAccountManager = 4,
  FinanceManager = 5,
}

export enum PaybevInvestmentStatus {
  Confirmed = 1,
  Unconfirmed = 2,
  // EditDate = 5,
  CancellationUnderReview = 6,
  PastDue = 7,
}

export enum BrooklynInvestmentStatus {
  PendingApproval = 1,
  UnderReview = 2,
  Processing = 3,
  EstimateSent = 4,
  Completed = 5,
  CancellationUnderReview = 6,
  canceled = 7,
  InvoiceSent = 8,
  InvoicePaid = 9,
  Voided = 10,
  Deleted = 11,
}

export enum NonAlcSitesTransactionType {
  Investment = 1,
  Payment = 2,
  Transfer = 3,
  Expense = 4,
  InternalTransfer = 5,
  Refunds = 6,
  Credits = 7,
  Deposits = 8,
}

export { EndPoints } from './endpoints/endpoints';
